import { trackCheckoutProgress } from '../../../../../../shared/analytics/e-commerce/trackCheckoutProgress';
import { INewBooking } from '../../../../../domain/booking/models/INewBooking';
import { adaptNewBookingToItems } from './adapters/adaptNewBookingToItems';
import { CheckoutSteps } from './CheckoutSteps';

export function trackStartPayment(booking: INewBooking) {
	const items = adaptNewBookingToItems(booking);

	if (!items) {
		return;
	}

	trackCheckoutProgress({
		items,
		coupon: booking.promoCode,
		step: CheckoutSteps.Payment,
	});
}
